import React from 'react';
import ReactDOM from 'react-dom';
import EmailCapturePopup from './src/components/EmailCapturePopup';
import ChatBotComponent from './src/components/ChatBotComponent';
import AnalyticsComponent from './src/components/AnalyticsComponent';
import { LocationProvider } from '@reach/router';
import Root from './src/Root';
import { ThemeProvider } from 'styled-components';
import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
} from '@mui/material/styles';
import DialogProvider from './src/components/v5/Dialog/index';
// import 'firebase/auth';
/*
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import GlobalContextProvider from './src/context/GlobalContextProvider';
import { ProvideAuth } from './src/firebase/useAuth';
import './src/styles/bootstrap.min.css';
import './src/css/typography.css';
import './src/sass/global.scss';
import './src/pages/index.css';
import './src/styles/tailwind.css';
// import { loadableReady } from '@loadable/component';

let disableOnPaths = [
  '/phonepe-tech-scholars-program',
  '/crio-winter-of-doing',
  '/registered',
  '/registration',
  '/launch',
  '/lister-beyond-your-break-program',
  '/geektrust-tech-scholars-program',
  '/error/404',
  '/ibelieveindoing',
  '/crio-reboot',
  '/automation-edge',
];
// all available props
const theme = {
  background: '#f5f8fb',
  fontFamily:
    'Rubik,Helvetica Neue,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol',
  headerBgColor: '#7bba8c',
  headerFontColor: '#fff',
  headerFontSize: '15px',
  botBubbleColor: '#fff',
  botFontColor: '#4a4a4a',
  userBubbleColor: '#7bba8c',
  userFontColor: '#fff',
};

const muiTheme = createTheme({
  palette: {
    primary: {
      main: '#7bba8c',
    },
    yellow: '#FF980E',
    secondary: {
      main: '#075353',
    },
  },
});
const stripTrailingSlash = (str) =>
  str.charAt(str.length - 1) == '/' && str.length > 1
    ? str.substr(0, str.length - 1)
    : str;

export const replaceHydrateFunction = () => {
  if (!['/'].includes(stripTrailingSlash(window.location.pathname))) {
    return (element, container, callback) => {
      ReactDOM.render(element, container, callback);
    };
  }
};

// export function replaceHydrateFunction() {
//   return (element, container, callback) => {
//     ReactDOM.render(element, container, callback);
//   };
// }

export function shouldUpdateScroll({ routerProps: { location } }) {
  if (!Boolean(location.hash)) {
    window.scrollTo(0, 0);
    const body = document.getElementsByTagName('body')[0];
    body.scrollTop = 0;
    return false;
  }
}

export const wrapRootElement = ({ element }) => (
  <LocationProvider>
    <GlobalContextProvider>
      <ProvideAuth>
        <MuiThemeProvider theme={muiTheme}>
          <DialogProvider>
            <Root>
              <AnalyticsComponent>
                <ThemeProvider theme={theme}>{element}</ThemeProvider>
              </AnalyticsComponent>
            </Root>
          </DialogProvider>
        </MuiThemeProvider>
      </ProvideAuth>
    </GlobalContextProvider>
  </LocationProvider>
);

// export const onInitialClientRender = () => {
//   document.getElementsByTagName('html')[0].style = 'opacity:1';
// };

export const wrapPageElement = ({ element, props }) => {
  return (
    <>
      {element}
      {!disableOnPaths.some((ele) =>
        (window?.location?.pathname).includes(ele),
      ) && (
        <>
          <EmailCapturePopup sale={props?.data?.strapiSale?.SaleID || ''} />
          <ChatBotComponent />
        </>
      )}
    </>
  );
};

// const activateOptimize = () => {
//   window.dataLayer = window.dataLayer || [];
//   window.dataLayer.push({ event: 'optimize.activate' });
// };
// export const onRouteUpdate = () => {
//   // ...
//   activateOptimize();
// };
